/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Mail_EditInputs */



/**
* | output |
* | --- |
* | "Edit email" |
*
* @param {Chat_Outlook_Mail_EditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_mail_edit = /** @type {((inputs?: Chat_Outlook_Mail_EditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Mail_EditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail bearbeiten")
	return /** @type {LocalizedString} */ ("Edit email")
});